import { IconFileText, IconMessageChatbot, IconRobot } from '@tabler/icons-react'
import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useOwlbertWebAuth } from './auth/OwlbertWebAuthContext'

function tabSelected(pathname: string, tab: 'chat' | 'assistants' | 'docs'): boolean {
  if (tab === 'chat') return pathname === '/assistants' || pathname.startsWith('/assistants/')
  if (tab === 'assistants') return pathname === '/assistants-config'
  if (tab === 'docs') return pathname === '/user-documents'
  return false
}

export const WebMobileTabBar: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const pathname = location.pathname
  const auth = useOwlbertWebAuth()
  const docsDisabled = !auth.workspaceId

  return (
    <nav className="owlbert-web-mobile-tabbar" aria-label="Workspace">
      <div className="owlbert-web-mobile-tabbar-main" role="tablist">
        <button
          type="button"
          role="tab"
          aria-selected={tabSelected(pathname, 'chat')}
          className={`owlbert-web-mobile-tab ${tabSelected(pathname, 'chat') ? 'is-selected' : ''}`}
          aria-label="Chats"
          onClick={() => navigate('/assistants')}
        >
          <span className="owlbert-web-mobile-tab-icon" aria-hidden>
            <IconMessageChatbot size={28} stroke={1.2} />
          </span>
          <span className="owlbert-web-mobile-tab-label">Chats</span>
        </button>

        <button
          type="button"
          role="tab"
          aria-selected={tabSelected(pathname, 'docs')}
          className={`owlbert-web-mobile-tab ${tabSelected(pathname, 'docs') ? 'is-selected' : ''}`}
          aria-label="Documents"
          disabled={docsDisabled}
          title={docsDisabled ? 'Pick a workspace to use documents' : undefined}
          onClick={() => {
            if (!docsDisabled) navigate('/user-documents')
          }}
        >
          <span className="owlbert-web-mobile-tab-icon" aria-hidden>
            <IconFileText size={28} stroke={1.2} />
          </span>
          <span className="owlbert-web-mobile-tab-label">Docs</span>
        </button>

        <button
          type="button"
          role="tab"
          aria-selected={tabSelected(pathname, 'assistants')}
          className={`owlbert-web-mobile-tab ${tabSelected(pathname, 'assistants') ? 'is-selected' : ''}`}
          aria-label="Assistants"
          onClick={() => navigate('/assistants-config')}
        >
          <span className="owlbert-web-mobile-tab-icon" aria-hidden>
            <IconRobot size={28} stroke={1.2} />
          </span>
          <span className="owlbert-web-mobile-tab-label">Assistants</span>
        </button>
      </div>
    </nav>
  )
}
